import {useCallback, useMemo, useState} from 'react';

// used in component with single modal
export function useModal(isDefaultOpen = false): {
  isModalOpen: boolean;
  closeModal: () => void;
  openModal: () => void;
  setModal: (isOpen: boolean) => void;
} {
  const [isModalOpen, setIsModalOpen] = useState(isDefaultOpen);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  return useMemo(
    () => ({isModalOpen, closeModal, openModal, setModal: setIsModalOpen}),
    [closeModal, isModalOpen, openModal]
  );
}

// used in component with >1 modals
export function useModals(defaultModal?: number): {
  modal?: number;
  closeModal: () => void;
  openModal: (modal: number) => void;
  setModal: (modal: number | undefined) => void;
} {
  const [modal, _setModal] = useState<number | undefined>(defaultModal);

  const closeModal = useCallback(() => {
    _setModal(undefined);
  }, []);

  const openModal = useCallback((modal: number) => {
    _setModal(modal);
  }, []);

  const setModal = useCallback((modal: number | undefined) => {
    _setModal(modal);
  }, []);

  return useMemo(
    () => ({modal, closeModal, openModal, setModal}),
    [closeModal, modal, openModal, setModal]
  );
}
